export default function StatusBadge({ status }) {
  let classes = "px-1 py-0.5 rounded text-[10px] font-semibold ";
  const normalized = (status || "").toLowerCase();
  switch (normalized) {
    case "pending":
      classes += "bg-yellow-100 text-yellow-700";
      break;
    case "in_progress":
    case "in progress":
      classes += "bg-blue-100 text-blue-700";
      break;
    case "completed":
      classes += "bg-green-100 text-green-700";
      break;
    case "delivered":
      classes += "bg-gray-200 text-gray-700";
      break;
    default:
      classes += "bg-gray-100 text-gray-700";
  }
  return (
    <span className={classes}>
      {status.charAt(0).toUpperCase() + status.slice(1).replace('_', ' ')}
    </span>
  );
}
